import { Attributes, LookupBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class ParticipantIncentiveSchemeTypeTaxRateLookup extends LookupBase {

    public incentiveSchemeTypeId: number = 0;

    @Attributes.Float()
    public taxRate: number = 0;
}